<template>
  <!-- Try it (type D): copy on one side, a small demo the visitor drives on the other. It never
       moves on its own. `chapter.demo` names the demo; each is its own lazy chunk and keeps its
       sample text untranslated, like other product mockups. -->
  <section class="sti">
    <div class="sti-shell sti-grid">
      <header class="sti-heading">
        <h2>{{ chapter.title }}</h2>
        <p class="sti-intro">{{ chapter.intro }}</p>
        <ul v-if="chapter.points?.length" class="sti-points">
          <li v-for="point in chapter.points" :key="point">{{ point }}</li>
        </ul>
      </header>
      <div class="sti-demo">
        <LazyStoryDemoCatalog v-if="chapter.demo === 'catalog'" :chapter="chapter" />
        <LazyStoryDemoInstallments v-else-if="chapter.demo === 'installments'" :chapter="chapter" />
        <LazyStoryDemoAddons v-else-if="chapter.demo === 'addons'" :chapter="chapter" />
        <LazyStoryDemoSigningOrder v-else-if="chapter.demo === 'signing-order'" :chapter="chapter" />
        <LazyStoryDemoHourBank v-else-if="chapter.demo === 'hourbank'" :chapter="chapter" />
        <LazyStoryDemoPortalLook v-else-if="chapter.demo === 'portal-look'" :chapter="chapter" />
        <p class="sti-note">{{ chapter.note }}</p>
      </div>
    </div>
  </section>
</template>

<script setup>
defineProps({
  chapter: { type: Object, required: true },
});
</script>

<style scoped>
.sti { background: #fff; padding: 6.5rem 0; }
.dark .sti { background: #020617; }
.sti-shell { width: min(100% - 3rem, 84rem); margin: 0 auto; }
.sti-grid { display: grid; gap: 2.5rem; align-items: center; }
@media (min-width: 1024px) { .sti-grid { grid-template-columns: minmax(0, 0.95fr) minmax(0, 1.05fr); gap: 4.5rem; } }
.sti-heading h2 { color: #020617; font-size: clamp(2rem, 4vw, 3.25rem); font-weight: 880; line-height: 1.04; text-wrap: balance; }
.dark .sti-heading h2 { color: #f8fafc; }
.sti-intro { margin-top: 1rem; color: #475569; font-size: 1rem; line-height: 1.7; }
.dark .sti-intro { color: #cbd5e1; }
.sti-points { display: grid; gap: 0.5rem; margin-top: 1.25rem; padding: 0; list-style: none; }
.sti-points li { position: relative; padding-left: 1rem; color: #334155; font-size: 0.95rem; line-height: 1.55; }
.dark .sti-points li { color: #cbd5e1; }
.sti-points li::before { content: ""; position: absolute; top: 0.6em; left: 0; width: 6px; height: 6px; border-radius: 2px; background: #1ba7ce; }
.sti-demo {
  border-radius: 14px;
  background:
    radial-gradient(circle, rgb(0 0 0 / 0.08) 0.8px, transparent 1.3px) 7px 7px / 14px 14px,
    linear-gradient(135deg, rgb(124 155 224 / 0.12), rgb(159 139 230 / 0.06));
  padding: 2rem;
}
.dark .sti-demo { background: radial-gradient(circle, rgb(255 255 255 / 0.1) 0.8px, transparent 1.3px) 7px 7px / 14px 14px, linear-gradient(135deg, rgb(124 155 224 / 0.12), rgb(159 139 230 / 0.05)); }
.sti-note { max-width: 520px; margin: 0.75rem auto 0; color: #475569; font-size: 0.82rem; }
.dark .sti-note { color: #a8b3c4; }
@media (max-width: 639px) {
  .sti { padding: 4.5rem 0; }
  .sti-shell { width: min(100% - 2rem, 84rem); }
  .sti-demo { padding: 0.9rem; }
}
</style>
